export const serviceTranslations = {
  en: {
    common: {
      getStarted: "Get Started",
      requestDemo: "Request Demo",
      contactUs: "Contact Us",
      learnMore: "Learn More",
      integration: "Integration Steps",
      faq: "Frequently Asked Questions",
      partners: "Our Partners",
      features: "Key Features",
      benefits: "Benefits",
      stats: "By The Numbers",
      backToHome: "Back to Home",
      quickContact: "Quick Contact",
      sendInquiry: "Send Inquiry",
      name: "Your Name",
      email: "Email Address",
      message: "Message",
      sending: "Sending...",
      sent: "Message sent!"
    },
    aggregator: {
      hero: {
        label: "Game Aggregation",
        title: "iGaming Aggregator",
        subtitle: "Access 10,000+ casino games from 100+ premium providers through a single, powerful API integration."
      },
      stats: [
        { value: "10,000+", label: "Games" },
        { value: "100+", label: "Providers" },
        { value: "99.9%", label: "Uptime" },
        { value: "50ms", label: "Response Time" }
      ],
      features: [
        {
          title: "Single API Integration",
          desc: "Connect once and access all game providers instantly. No need for multiple integrations."
        },
        {
          title: "Real-time Updates",
          desc: "Games are automatically updated with new releases and patches from all providers."
        },
        {
          title: "Unified Wallet",
          desc: "Single wallet system for all games, simplifying player balance management."
        },
        {
          title: "Analytics Dashboard",
          desc: "Comprehensive reporting with player behavior, game performance, and revenue analytics."
        },
        {
          title: "Seamless Bonus Engine",
          desc: "Apply bonuses and promotions across all games with our integrated bonus system."
        },
        {
          title: "Multi-Currency Support",
          desc: "Support for 50+ fiat currencies and major cryptocurrencies."
        }
      ],
      partners: [
        "1Spin4win", "172 Gaming", "5 Men", "Amatic", "Apollo", "Asia Gaming", "Belatra", "Bet2 Tech", "Betsoft", "BGaming",
        "Big Time Gaming", "Blueprint", "Booming Games", "Booongo", "Casino Technology", "EGT", "EGT Digital", "ELK Studios",
        "Endorphina", "Evolution Gaming", "Evoplay", "Ezugi", "Fantasma", "Fazi", "Felix Gaming", "Fugaso", "GameArt",
        "Gamomat", "Golden Hero", "Goldenrace", "Habanero", "Hacksaw Gaming", "High5", "Hollegames", "iSoftBet",
        "Iron Dog Studio", "Kalamba", "Kiron", "Live Games", "Lucky Streak", "Mancala", "Mascot Gaming", "Microgaming",
        "Mr Slotty", "NetEnt", "NetGame", "Nolimit City", "Onlyplay", "Oryx", "Platiplus", "Play'n GO", "Playson",
        "Playtech", "Playtech Live", "Pragmatic Play", "Pragmatic PLAY Live", "Push Gaming", "Quickspin", "Red Rake Gaming",
        "Red Tiger Gaming", "Reevo", "Relax Gaming", "Smartsoft", "Spade Gaming", "Spearhead", "Spinomenal", "Spribe",
        "Swintt", "Thunderkick", "Tom Horn", "Vivo Gaming", "Wazdan", "Yggdrasil", "Apparat Gaming", "BeeFee Gaming",
        "Bet Games", "Caleta Gaming", "Darwin Gaming", "DLV Games", "G Games", "Jade Rabbit", "JVL", "Koreagaming",
        "Live88", "Microgaming Live", "Novomatic", "Pascal", "Peter & Sons", "PG Soft", "Popok", "RAW iGaming",
        "Rival Powered", "RubyPlay", "Skywind", "Skywind Live", "Stakelogic", "Stakelogic Live", "TopSpin Games",
        "Turbo Games", "Upgaming", "Urgent Games", "WinFast", "WorldMatch", "Xpro Gaming", "YGR Games"
      ],
      integration: [
        { step: 1, title: "Sign Agreement", desc: "Complete the partnership agreement and receive your API credentials." },
        { step: 2, title: "API Integration", desc: "Integrate our unified API into your platform using comprehensive documentation." },
        { step: 3, title: "Testing", desc: "Test all game providers in our sandbox environment." },
        { step: 4, title: "Go Live", desc: "Launch with full access to 10,000+ games." }
      ],
      faq: [
        { q: "How long does integration take?", a: "Typical integration takes 2-4 weeks depending on your platform's complexity." },
        { q: "What currencies are supported?", a: "We support 50+ fiat currencies and all major cryptocurrencies including BTC, ETH, and USDT." },
        { q: "Is there a minimum volume requirement?", a: "We offer flexible plans for operators of all sizes. Contact us for custom pricing." },
        { q: "Do you provide technical support?", a: "Yes, we offer 24/7 technical support with dedicated account managers." }
      ]
    },
    platform: {
      hero: {
        label: "White Label Solution",
        title: "iGaming Platform",
        subtitle: "Launch your online casino in weeks with our fully customizable white-label platform."
      },
      stats: [
        { value: "500+", label: "Active Casinos" },
        { value: "2 Weeks", label: "Launch Time" },
        { value: "24/7", label: "Support" },
        { value: "100%", label: "Customizable" }
      ],
      features: [
        {
          title: "Complete Casino Solution",
          desc: "Everything you need: games, payments, CRM, bonus engine, and admin panel."
        },
        {
          title: "Custom Branding",
          desc: "Fully customizable design to match your brand identity and vision."
        },
        {
          title: "Player Management",
          desc: "Advanced CRM tools for player segmentation, retention, and VIP management."
        },
        {
          title: "Responsible Gaming",
          desc: "Built-in tools for deposit limits, self-exclusion, and player protection."
        },
        {
          title: "Multi-Tenant Architecture",
          desc: "Run multiple brands from a single platform with isolated player pools."
        },
        {
          title: "Regulatory Compliance",
          desc: "Pre-configured compliance tools for major jurisdictions worldwide."
        }
      ],
      partners: ["MGA Licensed", "Curacao eGaming", "UKGC Ready", "ISO 27001", "GLI Certified", "eCOGRA"],
      integration: [
        { step: 1, title: "Requirements", desc: "Share your requirements and brand guidelines with our team." },
        { step: 2, title: "Setup", desc: "We configure and customize the platform to your specifications." },
        { step: 3, title: "Training", desc: "Comprehensive training for your operations and support team." },
        { step: 4, title: "Launch", desc: "Go live with ongoing support and optimization." }
      ],
      faq: [
        { q: "Can I use my own domain?", a: "Yes, the platform runs entirely under your brand with your domain." },
        { q: "What licenses do I need?", a: "We can advise on licensing requirements and connect you with licensing partners." },
        { q: "Is the source code included?", a: "We offer both SaaS and source code licensing options." },
        { q: "How do updates work?", a: "Platform updates are deployed automatically with zero downtime." }
      ]
    },
    payments: {
      hero: {
        label: "Payment Processing",
        title: "iGaming Payments",
        subtitle: "Seamless payment processing with 200+ payment methods and instant settlements."
      },
      stats: [
        { value: "200+", label: "Payment Methods" },
        { value: "€50B+", label: "Processed Annually" },
        { value: "3s", label: "Avg. Deposit Time" },
        { value: "150+", label: "Countries" }
      ],
      features: [
        {
          title: "Global Coverage",
          desc: "Accept payments from 150+ countries with localized payment methods."
        },
        {
          title: "Instant Deposits",
          desc: "Real-time payment processing with average deposit time under 3 seconds."
        },
        {
          title: "Smart Routing",
          desc: "AI-powered routing optimizes success rates and minimizes processing costs."
        },
        {
          title: "Fraud Prevention",
          desc: "Advanced fraud detection with machine learning and risk scoring."
        },
        {
          title: "Chargeback Protection",
          desc: "Comprehensive chargeback management and dispute resolution."
        },
        {
          title: "Automated Payouts",
          desc: "Schedule and automate player withdrawals with compliance checks."
        }
      ],
      partners: ["Visa", "Mastercard", "Skrill", "Neteller", "PayPal", "Apple Pay", "Google Pay", "Bank Transfer"],
      integration: [
        { step: 1, title: "Onboarding", desc: "Complete KYB verification and merchant setup." },
        { step: 2, title: "Integration", desc: "Implement our payment API or use hosted payment pages." },
        { step: 3, title: "Configuration", desc: "Configure payment methods, limits, and routing rules." },
        { step: 4, title: "Processing", desc: "Start processing payments with real-time monitoring." }
      ],
      faq: [
        { q: "What are the transaction fees?", a: "Fees vary by payment method and volume. Contact us for a custom quote." },
        { q: "How fast are withdrawals?", a: "Most withdrawals are processed within 24 hours, many instantly." },
        { q: "Do you handle currency conversion?", a: "Yes, we offer competitive FX rates for multi-currency processing." },
        { q: "What about high-risk processing?", a: "We specialize in iGaming payments with established acquiring relationships." }
      ]
    },
    crypto: {
      hero: {
        label: "Cryptocurrency Solutions",
        title: "Crypto Payments",
        subtitle: "Accept 50+ cryptocurrencies with instant settlements and zero chargebacks."
      },
      stats: [
        { value: "50+", label: "Cryptocurrencies" },
        { value: "0%", label: "Chargebacks" },
        { value: "<1min", label: "Settlement" },
        { value: "0.5%", label: "Processing Fee" }
      ],
      features: [
        {
          title: "Multi-Chain Support",
          desc: "Accept payments on Bitcoin, Ethereum, BSC, Tron, Solana, and more."
        },
        {
          title: "Instant Conversion",
          desc: "Auto-convert crypto to stablecoins or fiat to eliminate volatility."
        },
        {
          title: "Zero Chargebacks",
          desc: "Blockchain transactions are irreversible, eliminating chargeback fraud."
        },
        {
          title: "Hot & Cold Wallets",
          desc: "Enterprise-grade security with multi-sig wallets and cold storage."
        },
        {
          title: "Stablecoin Support",
          desc: "Full support for USDT, USDC, DAI, and other major stablecoins."
        },
        {
          title: "DeFi Integration",
          desc: "Optional yield generation on idle funds through secure DeFi protocols."
        }
      ],
      partners: ["Bitcoin", "Ethereum", "USDT", "USDC", "Litecoin", "Ripple", "Solana", "Tron"],
      integration: [
        { step: 1, title: "Wallet Setup", desc: "Configure your merchant wallet addresses and security settings." },
        { step: 2, title: "API Integration", desc: "Implement our crypto payment API with webhook notifications." },
        { step: 3, title: "Testing", desc: "Test transactions on testnets before going live." },
        { step: 4, title: "Launch", desc: "Start accepting crypto payments with real-time tracking." }
      ],
      faq: [
        { q: "How do you handle volatility?", a: "We offer instant conversion to stablecoins or fiat at the time of transaction." },
        { q: "What about regulatory compliance?", a: "We provide full KYC/AML tools and transaction monitoring." },
        { q: "Are there volume limits?", a: "No limits on transaction volume. We scale with your business." },
        { q: "How secure is the system?", a: "Enterprise security with multi-sig wallets, cold storage, and insurance coverage." }
      ]
    }
  },
  tr: {
    common: {
      getStarted: "Başlayın",
      requestDemo: "Demo Talep Et",
      contactUs: "Bize Ulaşın",
      learnMore: "Daha Fazla",
      integration: "Entegrasyon Adımları",
      faq: "Sıkça Sorulan Sorular",
      partners: "İş Ortaklarımız",
      features: "Temel Özellikler",
      benefits: "Avantajlar",
      stats: "Rakamlarla Biz",
      backToHome: "Ana Sayfaya Dön",
      quickContact: "Hızlı İletişim",
      sendInquiry: "Gönder",
      name: "Adınız",
      email: "E-posta Adresiniz",
      message: "Mesajınız",
      sending: "Gönderiliyor...",
      sent: "Mesaj gönderildi!"
    },
    aggregator: {
      hero: {
        label: "Game Aggregation",
        title: "iGaming Aggregator",
        subtitle: "Tek ve güçlü bir API entegrasyonu ile 100+ premium sağlayıcıdan 10.000+ casino oyununa erişin."
      },
      stats: [
        { value: "10,000+", label: "Oyun" },
        { value: "100+", label: "Provider" },
        { value: "99.9%", label: "Uptime" },
        { value: "50ms", label: "Yanıt Süresi" }
      ],
      features: [
        {
          title: "Tek API Entegrasyonu",
          desc: "Bir kez bağlanın ve tüm oyun sağlayıcılarına anında erişin."
        },
        {
          title: "Gerçek Zamanlı Güncellemeler",
          desc: "Oyunlar tüm sağlayıcılardan yeni sürümler ve yamalarla otomatik güncellenir."
        },
        {
          title: "Birleşik Cüzdan",
          desc: "Tüm oyunlar için tek cüzdan sistemi, oyuncu bakiye yönetimini basitleştirir."
        },
        {
          title: "Analitik Paneli",
          desc: "Oyuncu davranışı, oyun performansı ve gelir analitiği ile kapsamlı raporlama."
        },
        {
          title: "Kesintisiz Bonus Motoru",
          desc: "Entegre bonus sistemimiz ile tüm oyunlarda bonus ve promosyonları uygulayın."
        },
        {
          title: "Çoklu Para Birimi Desteği",
          desc: "50+ fiat para birimi ve başlıca kripto para birimleri desteği."
        }
      ],
      partners: [
        "1Spin4win", "172 Gaming", "5 Men", "Amatic", "Apollo", "Asia Gaming", "Belatra", "Bet2 Tech", "Betsoft", "BGaming",
        "Big Time Gaming", "Blueprint", "Booming Games", "Booongo", "Casino Technology", "EGT", "EGT Digital", "ELK Studios",
        "Endorphina", "Evolution Gaming", "Evoplay", "Ezugi", "Fantasma", "Fazi", "Felix Gaming", "Fugaso", "GameArt",
        "Gamomat", "Golden Hero", "Goldenrace", "Habanero", "Hacksaw Gaming", "High5", "Hollegames", "iSoftBet",
        "Iron Dog Studio", "Kalamba", "Kiron", "Live Games", "Lucky Streak", "Mancala", "Mascot Gaming", "Microgaming",
        "Mr Slotty", "NetEnt", "NetGame", "Nolimit City", "Onlyplay", "Oryx", "Platiplus", "Play'n GO", "Playson",
        "Playtech", "Playtech Live", "Pragmatic Play", "Pragmatic PLAY Live", "Push Gaming", "Quickspin", "Red Rake Gaming",
        "Red Tiger Gaming", "Reevo", "Relax Gaming", "Smartsoft", "Spade Gaming", "Spearhead", "Spinomenal", "Spribe",
        "Swintt", "Thunderkick", "Tom Horn", "Vivo Gaming", "Wazdan", "Yggdrasil", "Apparat Gaming", "BeeFee Gaming",
        "Bet Games", "Caleta Gaming", "Darwin Gaming", "DLV Games", "G Games", "Jade Rabbit", "JVL", "Koreagaming",
        "Live88", "Microgaming Live", "Novomatic", "Pascal", "Peter & Sons", "PG Soft", "Popok", "RAW iGaming",
        "Rival Powered", "RubyPlay", "Skywind", "Skywind Live", "Stakelogic", "Stakelogic Live", "TopSpin Games",
        "Turbo Games", "Upgaming", "Urgent Games", "WinFast", "WorldMatch", "Xpro Gaming", "YGR Games"
      ],
      integration: [
        { step: 1, title: "Sözleşme İmzalama", desc: "Ortaklık sözleşmesini tamamlayın ve API kimlik bilgilerinizi alın." },
        { step: 2, title: "API Entegrasyonu", desc: "Kapsamlı dokümantasyon kullanarak birleşik API'mizi platformunuza entegre edin." },
        { step: 3, title: "Test", desc: "Sandbox ortamımızda tüm oyun sağlayıcılarını test edin." },
        { step: 4, title: "Canlıya Geçiş", desc: "10.000+ oyuna tam erişimle başlatın." }
      ],
      faq: [
        { q: "Entegrasyon ne kadar sürer?", a: "Tipik entegrasyon, platformunuzun karmaşıklığına bağlı olarak 2-4 hafta sürer." },
        { q: "Hangi para birimleri destekleniyor?", a: "50+ fiat para birimi ve BTC, ETH, USDT dahil tüm büyük kripto para birimlerini destekliyoruz." },
        { q: "Minimum hacim gereksinimi var mı?", a: "Her büyüklükteki operatör için esnek planlar sunuyoruz. Özel fiyatlandırma için bize ulaşın." },
        { q: "Teknik destek sağlıyor musunuz?", a: "Evet, özel hesap yöneticileri ile 7/24 teknik destek sunuyoruz." }
      ]
    },
    platform: {
      hero: {
        label: "Beyaz Etiket Çözümü",
        title: "iGaming Platform",
        subtitle: "Tamamen özelleştirilebilir beyaz etiket platformumuz ile online casinonuzu haftalar içinde başlatın."
      },
      stats: [
        { value: "500+", label: "Aktif Casino" },
        { value: "2 Hafta", label: "Lansman Süresi" },
        { value: "7/24", label: "Destek" },
        { value: "%100", label: "Özelleştirilebilir" }
      ],
      features: [
        {
          title: "Eksiksiz Casino Çözümü",
          desc: "İhtiyacınız olan her şey: oyunlar, ödemeler, CRM, bonus motoru ve yönetim paneli."
        },
        {
          title: "Özel Markalama",
          desc: "Marka kimliğinize ve vizyonunuza uygun tamamen özelleştirilebilir tasarım."
        },
        {
          title: "Oyuncu Yönetimi",
          desc: "Oyuncu segmentasyonu, tutma ve VIP yönetimi için gelişmiş CRM araçları."
        },
        {
          title: "Sorumlu Oyun",
          desc: "Para yatırma limitleri, kendini dışlama ve oyuncu koruması için yerleşik araçlar."
        },
        {
          title: "Çok Kiracılı Mimari",
          desc: "İzole oyuncu havuzları ile tek platformdan birden fazla marka yönetin."
        },
        {
          title: "Düzenleyici Uyumluluk",
          desc: "Dünya çapındaki büyük yetki alanları için önceden yapılandırılmış uyumluluk araçları."
        }
      ],
      partners: ["MGA Lisanslı", "Curacao eGaming", "UKGC Hazır", "ISO 27001", "GLI Sertifikalı", "eCOGRA"],
      integration: [
        { step: 1, title: "Gereksinimler", desc: "Gereksinimlerinizi ve marka kılavuzlarınızı ekibimizle paylaşın." },
        { step: 2, title: "Kurulum", desc: "Platformu özelliklerinize göre yapılandırıp özelleştiriyoruz." },
        { step: 3, title: "Eğitim", desc: "Operasyonlar ve destek ekibiniz için kapsamlı eğitim." },
        { step: 4, title: "Lansman", desc: "Sürekli destek ve optimizasyon ile canlıya geçin." }
      ],
      faq: [
        { q: "Kendi alan adımı kullanabilir miyim?", a: "Evet, platform tamamen kendi markanız ve alan adınız altında çalışır." },
        { q: "Hangi lisanslara ihtiyacım var?", a: "Lisans gereksinimleri konusunda danışmanlık yapabilir ve lisans ortaklarımızla bağlantı kurabiliriz." },
        { q: "Kaynak kodu dahil mi?", a: "Hem SaaS hem de kaynak kodu lisanslama seçenekleri sunuyoruz." },
        { q: "Güncellemeler nasıl çalışır?", a: "Platform güncellemeleri sıfır kesinti ile otomatik olarak dağıtılır." }
      ]
    },
    payments: {
      hero: {
        label: "Ödeme İşleme",
        title: "iGaming Ödemeler",
        subtitle: "200+ ödeme yöntemi ve anında hesaplaşma ile kesintisiz ödeme işleme."
      },
      stats: [
        { value: "200+", label: "Ödeme Yöntemi" },
        { value: "€50B+", label: "Yıllık İşlem" },
        { value: "3sn", label: "Ort. Para Yatırma" },
        { value: "150+", label: "Ülke" }
      ],
      features: [
        {
          title: "Global Kapsama",
          desc: "Yerelleştirilmiş ödeme yöntemleri ile 150+ ülkeden ödeme kabul edin."
        },
        {
          title: "Anında Para Yatırma",
          desc: "Ortalama para yatırma süresi 3 saniyenin altında gerçek zamanlı ödeme işleme."
        },
        {
          title: "Akıllı Yönlendirme",
          desc: "AI destekli yönlendirme başarı oranlarını optimize eder ve işleme maliyetlerini minimize eder."
        },
        {
          title: "Dolandırıcılık Önleme",
          desc: "Makine öğrenimi ve risk puanlaması ile gelişmiş dolandırıcılık tespiti."
        },
        {
          title: "Ters İbraz Koruması",
          desc: "Kapsamlı ters ibraz yönetimi ve anlaşmazlık çözümü."
        },
        {
          title: "Otomatik Ödemeler",
          desc: "Uyumluluk kontrolleri ile oyuncu çekimlerini planlayın ve otomatikleştirin."
        }
      ],
      partners: ["Visa", "Mastercard", "Skrill", "Neteller", "PayPal", "Apple Pay", "Google Pay", "Banka Havalesi"],
      integration: [
        { step: 1, title: "Kayıt", desc: "KYB doğrulamasını ve satıcı kurulumunu tamamlayın." },
        { step: 2, title: "Entegrasyon", desc: "Ödeme API'mizi uygulayın veya barındırılan ödeme sayfalarını kullanın." },
        { step: 3, title: "Yapılandırma", desc: "Ödeme yöntemlerini, limitleri ve yönlendirme kurallarını yapılandırın." },
        { step: 4, title: "İşleme", desc: "Gerçek zamanlı izleme ile ödemeleri işlemeye başlayın." }
      ],
      faq: [
        { q: "İşlem ücretleri nedir?", a: "Ücretler ödeme yöntemi ve hacme göre değişir. Özel teklif için bize ulaşın." },
        { q: "Para çekimler ne kadar hızlı?", a: "Çoğu para çekme 24 saat içinde işlenir, birçoğu anında." },
        { q: "Döviz dönüşümü yapıyor musunuz?", a: "Evet, çoklu para birimi işleme için rekabetçi döviz kurları sunuyoruz." },
        { q: "Yüksek riskli işleme ne olacak?", a: "Kurulu alıcı ilişkileri ile iGaming ödemelerinde uzmanlaşıyoruz." }
      ]
    },
    crypto: {
      hero: {
        label: "Kripto Para Çözümleri",
        title: "Kripto Ödemeler",
        subtitle: "Anında hesaplaşma ve sıfır ters ibraz ile 50+ kripto para birimi kabul edin."
      },
      stats: [
        { value: "50+", label: "Kripto Para" },
        { value: "%0", label: "Ters İbraz" },
        { value: "<1dk", label: "Hesaplaşma" },
        { value: "%0.5", label: "İşlem Ücreti" }
      ],
      features: [
        {
          title: "Çoklu Zincir Desteği",
          desc: "Bitcoin, Ethereum, BSC, Tron, Solana ve daha fazlasında ödeme kabul edin."
        },
        {
          title: "Anında Dönüşüm",
          desc: "Volatiliteyi ortadan kaldırmak için kripto'yu stablecoin veya fiat'a otomatik dönüştürün."
        },
        {
          title: "Sıfır Ters İbraz",
          desc: "Blockchain işlemleri geri alınamaz, ters ibraz dolandırıcılığını ortadan kaldırır."
        },
        {
          title: "Sıcak & Soğuk Cüzdanlar",
          desc: "Çoklu imzalı cüzdanlar ve soğuk depolama ile kurumsal düzeyde güvenlik."
        },
        {
          title: "Stablecoin Desteği",
          desc: "USDT, USDC, DAI ve diğer büyük stablecoin'ler için tam destek."
        },
        {
          title: "DeFi Entegrasyonu",
          desc: "Güvenli DeFi protokolleri aracılığıyla atıl fonlarda isteğe bağlı getiri üretimi."
        }
      ],
      partners: ["Bitcoin", "Ethereum", "USDT", "USDC", "Litecoin", "Ripple", "Solana", "Tron"],
      integration: [
        { step: 1, title: "Cüzdan Kurulumu", desc: "Satıcı cüzdan adreslerinizi ve güvenlik ayarlarınızı yapılandırın." },
        { step: 2, title: "API Entegrasyonu", desc: "Webhook bildirimleri ile kripto ödeme API'mizi uygulayın." },
        { step: 3, title: "Test", desc: "Canlıya geçmeden önce testnet'lerde işlemleri test edin." },
        { step: 4, title: "Lansman", desc: "Gerçek zamanlı takip ile kripto ödemeleri kabul etmeye başlayın." }
      ],
      faq: [
        { q: "Volatiliteyi nasıl yönetiyorsunuz?", a: "İşlem anında stablecoin veya fiat'a anında dönüşüm sunuyoruz." },
        { q: "Düzenleyici uyumluluk ne olacak?", a: "Tam KYC/AML araçları ve işlem izleme sağlıyoruz." },
        { q: "Hacim limitleri var mı?", a: "İşlem hacminde limit yok. İşletmenizle birlikte ölçekleniriz." },
        { q: "Sistem ne kadar güvenli?", a: "Çoklu imzalı cüzdanlar, soğuk depolama ve sigorta kapsamı ile kurumsal güvenlik." }
      ]
    }
  },
  de: {
    common: {
      getStarted: "Loslegen",
      requestDemo: "Demo Anfordern",
      contactUs: "Kontaktieren Sie uns",
      learnMore: "Mehr erfahren",
      integration: "Integrationsschritte",
      faq: "Häufig gestellte Fragen",
      partners: "Unsere Partner",
      features: "Hauptmerkmale",
      benefits: "Vorteile",
      stats: "In Zahlen",
      backToHome: "Zurück zur Startseite",
      quickContact: "Schnellkontakt",
      sendInquiry: "Anfrage senden",
      name: "Ihr Name",
      email: "E-Mail-Adresse",
      message: "Nachricht",
      sending: "Wird gesendet...",
      sent: "Nachricht gesendet!"
    },
    aggregator: {
      hero: {
        label: "Game Aggregation",
        title: "iGaming Aggregator",
        subtitle: "Zugriff auf 10.000+ Casinospiele von 100+ Premium-Anbietern über eine einzige, leistungsstarke API-Integration."
      },
      stats: [
        { value: "10.000+", label: "Spiele" },
        { value: "100+", label: "Anbieter" },
        { value: "99,9%", label: "Verfügbarkeit" },
        { value: "50ms", label: "Antwortzeit" }
      ],
      features: [
        { title: "Einzelne API-Integration", desc: "Einmal verbinden und sofort auf alle Spieleanbieter zugreifen." },
        { title: "Echtzeit-Updates", desc: "Spiele werden automatisch mit neuen Versionen aktualisiert." },
        { title: "Einheitliche Wallet", desc: "Ein Wallet-System für alle Spiele." },
        { title: "Analyse-Dashboard", desc: "Umfassende Berichterstattung mit Spielerverhalten und Umsatzanalysen." },
        { title: "Nahtlose Bonus-Engine", desc: "Wenden Sie Boni über alle Spiele hinweg an." },
        { title: "Multi-Währungsunterstützung", desc: "Unterstützung für 50+ Fiat-Währungen und Kryptowährungen." }
      ],
      partners: [
        "1Spin4win", "172 Gaming", "5 Men", "Amatic", "Apollo", "Asia Gaming", "Belatra", "Bet2 Tech", "Betsoft", "BGaming",
        "Big Time Gaming", "Blueprint", "Booming Games", "Booongo", "Casino Technology", "EGT", "EGT Digital", "ELK Studios",
        "Endorphina", "Evolution Gaming", "Evoplay", "Ezugi", "Fantasma", "Fazi", "Felix Gaming", "Fugaso", "GameArt",
        "Gamomat", "Golden Hero", "Goldenrace", "Habanero", "Hacksaw Gaming", "High5", "Hollegames", "iSoftBet",
        "Iron Dog Studio", "Kalamba", "Kiron", "Live Games", "Lucky Streak", "Mancala", "Mascot Gaming", "Microgaming",
        "Mr Slotty", "NetEnt", "NetGame", "Nolimit City", "Onlyplay", "Oryx", "Platiplus", "Play'n GO", "Playson",
        "Playtech", "Playtech Live", "Pragmatic Play", "Pragmatic PLAY Live", "Push Gaming", "Quickspin", "Red Rake Gaming",
        "Red Tiger Gaming", "Reevo", "Relax Gaming", "Smartsoft", "Spade Gaming", "Spearhead", "Spinomenal", "Spribe",
        "Swintt", "Thunderkick", "Tom Horn", "Vivo Gaming", "Wazdan", "Yggdrasil", "Apparat Gaming", "BeeFee Gaming",
        "Bet Games", "Caleta Gaming", "Darwin Gaming", "DLV Games", "G Games", "Jade Rabbit", "JVL", "Koreagaming",
        "Live88", "Microgaming Live", "Novomatic", "Pascal", "Peter & Sons", "PG Soft", "Popok", "RAW iGaming",
        "Rival Powered", "RubyPlay", "Skywind", "Skywind Live", "Stakelogic", "Stakelogic Live", "TopSpin Games",
        "Turbo Games", "Upgaming", "Urgent Games", "WinFast", "WorldMatch", "Xpro Gaming", "YGR Games"
      ],
      integration: [
        { step: 1, title: "Vertrag unterschreiben", desc: "Partnerschaftsvereinbarung abschließen." },
        { step: 2, title: "API-Integration", desc: "Unsere einheitliche API integrieren." },
        { step: 3, title: "Testen", desc: "Alle Anbieter in unserer Sandbox testen." },
        { step: 4, title: "Live gehen", desc: "Mit Zugriff auf 10.000+ Spiele starten." }
      ],
      faq: [
        { q: "Wie lange dauert die Integration?", a: "Typischerweise 2-4 Wochen." },
        { q: "Welche Währungen werden unterstützt?", a: "50+ Fiat und alle großen Kryptowährungen." },
        { q: "Gibt es Mindestvolumenanforderungen?", a: "Flexible Pläne für alle Größen." },
        { q: "Bieten Sie technischen Support?", a: "Ja, 24/7 mit dediziertem Account Manager." }
      ]
    },
    platform: {
      hero: {
        label: "White-Label-Lösung",
        title: "iGaming Platform",
        subtitle: "Starten Sie Ihr Online-Casino in Wochen mit unserer vollständig anpassbaren White-Label-Plattform."
      },
      stats: [
        { value: "500+", label: "Aktive Casinos" },
        { value: "2 Wochen", label: "Startzeit" },
        { value: "24/7", label: "Support" },
        { value: "100%", label: "Anpassbar" }
      ],
      features: [
        { title: "Komplette Casino-Lösung", desc: "Alles was Sie brauchen: Spiele, Zahlungen, CRM, Bonus-Engine." },
        { title: "Individuelles Branding", desc: "Vollständig anpassbares Design." },
        { title: "Spielerverwaltung", desc: "Erweiterte CRM-Tools." },
        { title: "Verantwortungsvolles Spielen", desc: "Eingebaute Schutztools." },
        { title: "Multi-Tenant-Architektur", desc: "Mehrere Marken von einer Plattform." },
        { title: "Regulatorische Compliance", desc: "Vorkonfigurierte Compliance-Tools." }
      ],
      partners: ["MGA Lizenziert", "Curacao eGaming", "UKGC Bereit", "ISO 27001", "GLI Zertifiziert", "eCOGRA"],
      integration: [
        { step: 1, title: "Anforderungen", desc: "Teilen Sie Ihre Anforderungen." },
        { step: 2, title: "Einrichtung", desc: "Wir konfigurieren die Plattform." },
        { step: 3, title: "Schulung", desc: "Umfassende Teamschulung." },
        { step: 4, title: "Start", desc: "Mit laufendem Support live gehen." }
      ],
      faq: [
        { q: "Kann ich meine eigene Domain nutzen?", a: "Ja, vollständig unter Ihrer Marke." },
        { q: "Welche Lizenzen brauche ich?", a: "Wir beraten zu Lizenzanforderungen." },
        { q: "Ist der Quellcode enthalten?", a: "SaaS und Quellcode-Optionen verfügbar." },
        { q: "Wie funktionieren Updates?", a: "Automatisch ohne Ausfallzeit." }
      ]
    },
    payments: {
      hero: {
        label: "Zahlungsabwicklung",
        title: "iGaming Payments",
        subtitle: "Nahtlose Zahlungsabwicklung mit 200+ Zahlungsmethoden."
      },
      stats: [
        { value: "200+", label: "Zahlungsmethoden" },
        { value: "€50B+", label: "Jährlich verarbeitet" },
        { value: "3s", label: "Durchschn. Einzahlung" },
        { value: "150+", label: "Länder" }
      ],
      features: [
        { title: "Globale Abdeckung", desc: "Zahlungen aus 150+ Ländern." },
        { title: "Sofortige Einzahlungen", desc: "Echtzeit-Verarbeitung." },
        { title: "Intelligentes Routing", desc: "KI-gestützte Optimierung." },
        { title: "Betrugsprävention", desc: "Erweiterte Betrugserkennung." },
        { title: "Rückbuchungsschutz", desc: "Umfassendes Management." },
        { title: "Automatisierte Auszahlungen", desc: "Geplante Auszahlungen." }
      ],
      partners: ["Visa", "Mastercard", "Skrill", "Neteller", "PayPal", "Apple Pay", "Google Pay", "Banküberweisung"],
      integration: [
        { step: 1, title: "Onboarding", desc: "KYB-Verifizierung abschließen." },
        { step: 2, title: "Integration", desc: "Zahlungs-API implementieren." },
        { step: 3, title: "Konfiguration", desc: "Zahlungsmethoden konfigurieren." },
        { step: 4, title: "Verarbeitung", desc: "Mit Echtzeit-Überwachung starten." }
      ],
      faq: [
        { q: "Was sind die Transaktionsgebühren?", a: "Abhängig von Methode und Volumen." },
        { q: "Wie schnell sind Auszahlungen?", a: "Meist innerhalb von 24 Stunden." },
        { q: "Bieten Sie Währungsumrechnung?", a: "Ja, wettbewerbsfähige Kurse." },
        { q: "Hochrisiko-Verarbeitung?", a: "Spezialisiert auf iGaming." }
      ]
    },
    crypto: {
      hero: {
        label: "Kryptowährungslösungen",
        title: "Crypto Payments",
        subtitle: "Akzeptieren Sie 50+ Kryptowährungen mit sofortiger Abwicklung."
      },
      stats: [
        { value: "50+", label: "Kryptowährungen" },
        { value: "0%", label: "Rückbuchungen" },
        { value: "<1min", label: "Abwicklung" },
        { value: "0,5%", label: "Gebühr" }
      ],
      features: [
        { title: "Multi-Chain-Support", desc: "Bitcoin, Ethereum, BSC, Tron, Solana." },
        { title: "Sofortige Konvertierung", desc: "Auto-Konvertierung zu Stablecoins." },
        { title: "Keine Rückbuchungen", desc: "Blockchain-Transaktionen sind endgültig." },
        { title: "Hot & Cold Wallets", desc: "Enterprise-Sicherheit." },
        { title: "Stablecoin-Support", desc: "USDT, USDC, DAI Support." },
        { title: "DeFi-Integration", desc: "Optionale Rendite-Generierung." }
      ],
      partners: ["Bitcoin", "Ethereum", "USDT", "USDC", "Litecoin", "Ripple", "Solana", "Tron"],
      integration: [
        { step: 1, title: "Wallet-Setup", desc: "Wallet-Adressen konfigurieren." },
        { step: 2, title: "API-Integration", desc: "Krypto-API implementieren." },
        { step: 3, title: "Testen", desc: "Auf Testnets testen." },
        { step: 4, title: "Start", desc: "Krypto-Zahlungen akzeptieren." }
      ],
      faq: [
        { q: "Wie handhaben Sie Volatilität?", a: "Sofortige Konvertierung zu Stablecoins." },
        { q: "Regulatorische Compliance?", a: "Volle KYC/AML-Tools." },
        { q: "Volumenlimits?", a: "Keine Limits." },
        { q: "Wie sicher ist das System?", a: "Enterprise-Sicherheit mit Versicherung." }
      ]
    }
  },
  fr: {
    common: {
      getStarted: "Commencer",
      requestDemo: "Demander une Démo",
      contactUs: "Contactez-nous",
      learnMore: "En savoir plus",
      integration: "Étapes d'Intégration",
      faq: "Questions Fréquentes",
      partners: "Nos Partenaires",
      features: "Fonctionnalités Clés",
      benefits: "Avantages",
      stats: "En Chiffres",
      backToHome: "Retour à l'Accueil",
      quickContact: "Contact Rapide",
      sendInquiry: "Envoyer",
      name: "Votre Nom",
      email: "Adresse Email",
      message: "Message",
      sending: "Envoi en cours...",
      sent: "Message envoyé!"
    },
    aggregator: {
      hero: {
        label: "Game Aggregation",
        title: "iGaming Aggregator",
        subtitle: "Accédez à 10 000+ jeux de casino de 100+ fournisseurs premium via une seule intégration API."
      },
      stats: [
        { value: "10 000+", label: "Jeux" },
        { value: "100+", label: "Fournisseurs" },
        { value: "99,9%", label: "Disponibilité" },
        { value: "50ms", label: "Temps de Réponse" }
      ],
      features: [
        { title: "Intégration API Unique", desc: "Connectez-vous une fois et accédez à tous les fournisseurs." },
        { title: "Mises à Jour en Temps Réel", desc: "Jeux automatiquement mis à jour." },
        { title: "Portefeuille Unifié", desc: "Système de portefeuille unique pour tous les jeux." },
        { title: "Tableau de Bord Analytique", desc: "Reporting complet avec analyses." },
        { title: "Moteur de Bonus Intégré", desc: "Appliquez des bonus sur tous les jeux." },
        { title: "Support Multi-Devises", desc: "50+ devises fiat et crypto." }
      ],
      partners: [
        "1Spin4win", "172 Gaming", "5 Men", "Amatic", "Apollo", "Asia Gaming", "Belatra", "Bet2 Tech", "Betsoft", "BGaming",
        "Big Time Gaming", "Blueprint", "Booming Games", "Booongo", "Casino Technology", "EGT", "EGT Digital", "ELK Studios",
        "Endorphina", "Evolution Gaming", "Evoplay", "Ezugi", "Fantasma", "Fazi", "Felix Gaming", "Fugaso", "GameArt",
        "Gamomat", "Golden Hero", "Goldenrace", "Habanero", "Hacksaw Gaming", "High5", "Hollegames", "iSoftBet",
        "Iron Dog Studio", "Kalamba", "Kiron", "Live Games", "Lucky Streak", "Mancala", "Mascot Gaming", "Microgaming",
        "Mr Slotty", "NetEnt", "NetGame", "Nolimit City", "Onlyplay", "Oryx", "Platiplus", "Play'n GO", "Playson",
        "Playtech", "Playtech Live", "Pragmatic Play", "Pragmatic PLAY Live", "Push Gaming", "Quickspin", "Red Rake Gaming",
        "Red Tiger Gaming", "Reevo", "Relax Gaming", "Smartsoft", "Spade Gaming", "Spearhead", "Spinomenal", "Spribe",
        "Swintt", "Thunderkick", "Tom Horn", "Vivo Gaming", "Wazdan", "Yggdrasil", "Apparat Gaming", "BeeFee Gaming",
        "Bet Games", "Caleta Gaming", "Darwin Gaming", "DLV Games", "G Games", "Jade Rabbit", "JVL", "Koreagaming",
        "Live88", "Microgaming Live", "Novomatic", "Pascal", "Peter & Sons", "PG Soft", "Popok", "RAW iGaming",
        "Rival Powered", "RubyPlay", "Skywind", "Skywind Live", "Stakelogic", "Stakelogic Live", "TopSpin Games",
        "Turbo Games", "Upgaming", "Urgent Games", "WinFast", "WorldMatch", "Xpro Gaming", "YGR Games"
      ],
      integration: [
        { step: 1, title: "Signature", desc: "Complétez l'accord de partenariat." },
        { step: 2, title: "Intégration API", desc: "Intégrez notre API unifiée." },
        { step: 3, title: "Tests", desc: "Testez dans notre environnement sandbox." },
        { step: 4, title: "Lancement", desc: "Lancez avec accès à 10 000+ jeux." }
      ],
      faq: [
        { q: "Combien de temps prend l'intégration?", a: "Généralement 2-4 semaines." },
        { q: "Quelles devises sont supportées?", a: "50+ fiat et toutes les principales crypto." },
        { q: "Y a-t-il un volume minimum?", a: "Plans flexibles pour toutes tailles." },
        { q: "Offrez-vous un support technique?", a: "Oui, 24/7 avec gestionnaire dédié." }
      ]
    },
    platform: {
      hero: {
        label: "Solution White Label",
        title: "iGaming Platform",
        subtitle: "Lancez votre casino en ligne en semaines avec notre plateforme white-label personnalisable."
      },
      stats: [
        { value: "500+", label: "Casinos Actifs" },
        { value: "2 Semaines", label: "Temps de Lancement" },
        { value: "24/7", label: "Support" },
        { value: "100%", label: "Personnalisable" }
      ],
      features: [
        { title: "Solution Casino Complète", desc: "Tout ce dont vous avez besoin." },
        { title: "Branding Personnalisé", desc: "Design entièrement personnalisable." },
        { title: "Gestion des Joueurs", desc: "Outils CRM avancés." },
        { title: "Jeu Responsable", desc: "Outils de protection intégrés." },
        { title: "Architecture Multi-Tenant", desc: "Plusieurs marques, une plateforme." },
        { title: "Conformité Réglementaire", desc: "Outils de conformité préconfigurés." }
      ],
      partners: ["MGA Licencié", "Curacao eGaming", "UKGC Ready", "ISO 27001", "GLI Certifié", "eCOGRA"],
      integration: [
        { step: 1, title: "Exigences", desc: "Partagez vos exigences." },
        { step: 2, title: "Configuration", desc: "Nous configurons la plateforme." },
        { step: 3, title: "Formation", desc: "Formation complète de l'équipe." },
        { step: 4, title: "Lancement", desc: "Mise en ligne avec support continu." }
      ],
      faq: [
        { q: "Puis-je utiliser mon domaine?", a: "Oui, entièrement sous votre marque." },
        { q: "Quelles licences me faut-il?", a: "Nous conseillons sur les licences." },
        { q: "Le code source est-il inclus?", a: "Options SaaS et code source disponibles." },
        { q: "Comment fonctionnent les mises à jour?", a: "Automatiquement sans interruption." }
      ]
    },
    payments: {
      hero: {
        label: "Traitement des Paiements",
        title: "iGaming Payments",
        subtitle: "Traitement fluide avec 200+ méthodes de paiement."
      },
      stats: [
        { value: "200+", label: "Méthodes" },
        { value: "€50B+", label: "Traité Annuellement" },
        { value: "3s", label: "Temps Moyen" },
        { value: "150+", label: "Pays" }
      ],
      features: [
        { title: "Couverture Mondiale", desc: "Paiements de 150+ pays." },
        { title: "Dépôts Instantanés", desc: "Traitement en temps réel." },
        { title: "Routage Intelligent", desc: "Optimisation par IA." },
        { title: "Prévention de Fraude", desc: "Détection avancée." },
        { title: "Protection Chargeback", desc: "Gestion complète." },
        { title: "Retraits Automatisés", desc: "Retraits programmés." }
      ],
      partners: ["Visa", "Mastercard", "Skrill", "Neteller", "PayPal", "Apple Pay", "Google Pay", "Virement"],
      integration: [
        { step: 1, title: "Inscription", desc: "Vérification KYB complète." },
        { step: 2, title: "Intégration", desc: "Implémentez notre API." },
        { step: 3, title: "Configuration", desc: "Configurez les méthodes." },
        { step: 4, title: "Traitement", desc: "Commencez avec monitoring." }
      ],
      faq: [
        { q: "Quels sont les frais?", a: "Selon méthode et volume." },
        { q: "Rapidité des retraits?", a: "Généralement sous 24h." },
        { q: "Conversion de devises?", a: "Oui, taux compétitifs." },
        { q: "Traitement à haut risque?", a: "Spécialisés en iGaming." }
      ]
    },
    crypto: {
      hero: {
        label: "Solutions Crypto",
        title: "Crypto Payments",
        subtitle: "Acceptez 50+ cryptomonnaies avec règlement instantané."
      },
      stats: [
        { value: "50+", label: "Cryptomonnaies" },
        { value: "0%", label: "Chargebacks" },
        { value: "<1min", label: "Règlement" },
        { value: "0,5%", label: "Frais" }
      ],
      features: [
        { title: "Support Multi-Chain", desc: "Bitcoin, Ethereum, BSC, Tron, Solana." },
        { title: "Conversion Instantanée", desc: "Auto-conversion en stablecoins." },
        { title: "Zéro Chargeback", desc: "Transactions irréversibles." },
        { title: "Hot & Cold Wallets", desc: "Sécurité entreprise." },
        { title: "Support Stablecoin", desc: "USDT, USDC, DAI." },
        { title: "Intégration DeFi", desc: "Génération de rendement optionnelle." }
      ],
      partners: ["Bitcoin", "Ethereum", "USDT", "USDC", "Litecoin", "Ripple", "Solana", "Tron"],
      integration: [
        { step: 1, title: "Configuration Wallet", desc: "Configurez vos adresses." },
        { step: 2, title: "Intégration API", desc: "Implémentez notre API crypto." },
        { step: 3, title: "Tests", desc: "Testez sur testnets." },
        { step: 4, title: "Lancement", desc: "Acceptez les paiements crypto." }
      ],
      faq: [
        { q: "Gestion de la volatilité?", a: "Conversion instantanée en stablecoins." },
        { q: "Conformité réglementaire?", a: "Outils KYC/AML complets." },
        { q: "Limites de volume?", a: "Aucune limite." },
        { q: "Sécurité du système?", a: "Sécurité entreprise avec assurance." }
      ]
    }
  },
  es: {
    common: {
      getStarted: "Comenzar",
      requestDemo: "Solicitar Demo",
      contactUs: "Contáctenos",
      learnMore: "Más información",
      integration: "Pasos de Integración",
      faq: "Preguntas Frecuentes",
      partners: "Nuestros Socios",
      features: "Características Clave",
      benefits: "Beneficios",
      stats: "En Números",
      backToHome: "Volver al Inicio",
      quickContact: "Contacto Rápido",
      sendInquiry: "Enviar",
      name: "Su Nombre",
      email: "Correo Electrónico",
      message: "Mensaje",
      sending: "Enviando...",
      sent: "¡Mensaje enviado!"
    },
    aggregator: {
      hero: {
        label: "Game Aggregation",
        title: "iGaming Aggregator",
        subtitle: "Acceda a 10,000+ juegos de casino de 100+ proveedores premium a través de una única integración API."
      },
      stats: [
        { value: "10,000+", label: "Juegos" },
        { value: "100+", label: "Proveedores" },
        { value: "99.9%", label: "Disponibilidad" },
        { value: "50ms", label: "Tiempo de Respuesta" }
      ],
      features: [
        { title: "Integración API Única", desc: "Conéctese una vez y acceda a todos los proveedores." },
        { title: "Actualizaciones en Tiempo Real", desc: "Juegos actualizados automáticamente." },
        { title: "Billetera Unificada", desc: "Sistema de billetera único para todos los juegos." },
        { title: "Panel de Análisis", desc: "Informes completos con análisis." },
        { title: "Motor de Bonos Integrado", desc: "Aplique bonos en todos los juegos." },
        { title: "Soporte Multi-Moneda", desc: "50+ monedas fiat y crypto." }
      ],
      partners: [
        "1Spin4win", "172 Gaming", "5 Men", "Amatic", "Apollo", "Asia Gaming", "Belatra", "Bet2 Tech", "Betsoft", "BGaming",
        "Big Time Gaming", "Blueprint", "Booming Games", "Booongo", "Casino Technology", "EGT", "EGT Digital", "ELK Studios",
        "Endorphina", "Evolution Gaming", "Evoplay", "Ezugi", "Fantasma", "Fazi", "Felix Gaming", "Fugaso", "GameArt",
        "Gamomat", "Golden Hero", "Goldenrace", "Habanero", "Hacksaw Gaming", "High5", "Hollegames", "iSoftBet",
        "Iron Dog Studio", "Kalamba", "Kiron", "Live Games", "Lucky Streak", "Mancala", "Mascot Gaming", "Microgaming",
        "Mr Slotty", "NetEnt", "NetGame", "Nolimit City", "Onlyplay", "Oryx", "Platiplus", "Play'n GO", "Playson",
        "Playtech", "Playtech Live", "Pragmatic Play", "Pragmatic PLAY Live", "Push Gaming", "Quickspin", "Red Rake Gaming",
        "Red Tiger Gaming", "Reevo", "Relax Gaming", "Smartsoft", "Spade Gaming", "Spearhead", "Spinomenal", "Spribe",
        "Swintt", "Thunderkick", "Tom Horn", "Vivo Gaming", "Wazdan", "Yggdrasil", "Apparat Gaming", "BeeFee Gaming",
        "Bet Games", "Caleta Gaming", "Darwin Gaming", "DLV Games", "G Games", "Jade Rabbit", "JVL", "Koreagaming",
        "Live88", "Microgaming Live", "Novomatic", "Pascal", "Peter & Sons", "PG Soft", "Popok", "RAW iGaming",
        "Rival Powered", "RubyPlay", "Skywind", "Skywind Live", "Stakelogic", "Stakelogic Live", "TopSpin Games",
        "Turbo Games", "Upgaming", "Urgent Games", "WinFast", "WorldMatch", "Xpro Gaming", "YGR Games"
      ],
      integration: [
        { step: 1, title: "Firma de Acuerdo", desc: "Complete el acuerdo de asociación." },
        { step: 2, title: "Integración API", desc: "Integre nuestra API unificada." },
        { step: 3, title: "Pruebas", desc: "Pruebe en nuestro entorno sandbox." },
        { step: 4, title: "Lanzamiento", desc: "Lance con acceso a 10,000+ juegos." }
      ],
      faq: [
        { q: "¿Cuánto tiempo toma la integración?", a: "Típicamente 2-4 semanas." },
        { q: "¿Qué monedas se soportan?", a: "50+ fiat y todas las principales crypto." },
        { q: "¿Hay volumen mínimo?", a: "Planes flexibles para todos los tamaños." },
        { q: "¿Ofrecen soporte técnico?", a: "Sí, 24/7 con gerente dedicado." }
      ]
    },
    platform: {
      hero: {
        label: "Solución White Label",
        title: "iGaming Platform",
        subtitle: "Lance su casino online en semanas con nuestra plataforma white-label personalizable."
      },
      stats: [
        { value: "500+", label: "Casinos Activos" },
        { value: "2 Semanas", label: "Tiempo de Lanzamiento" },
        { value: "24/7", label: "Soporte" },
        { value: "100%", label: "Personalizable" }
      ],
      features: [
        { title: "Solución Casino Completa", desc: "Todo lo que necesita." },
        { title: "Branding Personalizado", desc: "Diseño totalmente personalizable." },
        { title: "Gestión de Jugadores", desc: "Herramientas CRM avanzadas." },
        { title: "Juego Responsable", desc: "Herramientas de protección integradas." },
        { title: "Arquitectura Multi-Tenant", desc: "Múltiples marcas, una plataforma." },
        { title: "Cumplimiento Regulatorio", desc: "Herramientas de cumplimiento preconfiguradas." }
      ],
      partners: ["MGA Licenciado", "Curacao eGaming", "UKGC Ready", "ISO 27001", "GLI Certificado", "eCOGRA"],
      integration: [
        { step: 1, title: "Requisitos", desc: "Comparta sus requisitos." },
        { step: 2, title: "Configuración", desc: "Configuramos la plataforma." },
        { step: 3, title: "Capacitación", desc: "Capacitación completa del equipo." },
        { step: 4, title: "Lanzamiento", desc: "En vivo con soporte continuo." }
      ],
      faq: [
        { q: "¿Puedo usar mi dominio?", a: "Sí, completamente bajo su marca." },
        { q: "¿Qué licencias necesito?", a: "Asesoramos sobre licencias." },
        { q: "¿Está incluido el código fuente?", a: "Opciones SaaS y código fuente disponibles." },
        { q: "¿Cómo funcionan las actualizaciones?", a: "Automáticamente sin interrupción." }
      ]
    },
    payments: {
      hero: {
        label: "Procesamiento de Pagos",
        title: "iGaming Payments",
        subtitle: "Procesamiento fluido con 200+ métodos de pago."
      },
      stats: [
        { value: "200+", label: "Métodos" },
        { value: "€50B+", label: "Procesado Anualmente" },
        { value: "3s", label: "Tiempo Promedio" },
        { value: "150+", label: "Países" }
      ],
      features: [
        { title: "Cobertura Global", desc: "Pagos de 150+ países." },
        { title: "Depósitos Instantáneos", desc: "Procesamiento en tiempo real." },
        { title: "Enrutamiento Inteligente", desc: "Optimización con IA." },
        { title: "Prevención de Fraude", desc: "Detección avanzada." },
        { title: "Protección Chargeback", desc: "Gestión completa." },
        { title: "Retiros Automatizados", desc: "Retiros programados." }
      ],
      partners: ["Visa", "Mastercard", "Skrill", "Neteller", "PayPal", "Apple Pay", "Google Pay", "Transferencia"],
      integration: [
        { step: 1, title: "Registro", desc: "Verificación KYB completa." },
        { step: 2, title: "Integración", desc: "Implemente nuestra API." },
        { step: 3, title: "Configuración", desc: "Configure los métodos." },
        { step: 4, title: "Procesamiento", desc: "Comience con monitoreo." }
      ],
      faq: [
        { q: "¿Cuáles son las tarifas?", a: "Según método y volumen." },
        { q: "¿Rapidez de retiros?", a: "Generalmente en 24h." },
        { q: "¿Conversión de moneda?", a: "Sí, tasas competitivas." },
        { q: "¿Procesamiento de alto riesgo?", a: "Especializados en iGaming." }
      ]
    },
    crypto: {
      hero: {
        label: "Soluciones Crypto",
        title: "Crypto Payments",
        subtitle: "Acepte 50+ criptomonedas con liquidación instantánea."
      },
      stats: [
        { value: "50+", label: "Criptomonedas" },
        { value: "0%", label: "Chargebacks" },
        { value: "<1min", label: "Liquidación" },
        { value: "0.5%", label: "Tarifa" }
      ],
      features: [
        { title: "Soporte Multi-Chain", desc: "Bitcoin, Ethereum, BSC, Tron, Solana." },
        { title: "Conversión Instantánea", desc: "Auto-conversión a stablecoins." },
        { title: "Cero Chargebacks", desc: "Transacciones irreversibles." },
        { title: "Hot & Cold Wallets", desc: "Seguridad empresarial." },
        { title: "Soporte Stablecoin", desc: "USDT, USDC, DAI." },
        { title: "Integración DeFi", desc: "Generación de rendimiento opcional." }
      ],
      partners: ["Bitcoin", "Ethereum", "USDT", "USDC", "Litecoin", "Ripple", "Solana", "Tron"],
      integration: [
        { step: 1, title: "Configuración Wallet", desc: "Configure sus direcciones." },
        { step: 2, title: "Integración API", desc: "Implemente nuestra API crypto." },
        { step: 3, title: "Pruebas", desc: "Pruebe en testnets." },
        { step: 4, title: "Lanzamiento", desc: "Acepte pagos crypto." }
      ],
      faq: [
        { q: "¿Manejo de volatilidad?", a: "Conversión instantánea a stablecoins." },
        { q: "¿Cumplimiento regulatorio?", a: "Herramientas KYC/AML completas." },
        { q: "¿Límites de volumen?", a: "Sin límites." },
        { q: "¿Seguridad del sistema?", a: "Seguridad empresarial con seguro." }
      ]
    }
  },
  ru: {
    common: {
      getStarted: "Начать",
      requestDemo: "Запросить Демо",
      contactUs: "Связаться",
      learnMore: "Подробнее",
      integration: "Этапы Интеграции",
      faq: "Часто Задаваемые Вопросы",
      partners: "Наши Партнеры",
      features: "Ключевые Функции",
      benefits: "Преимущества",
      stats: "В Цифрах",
      backToHome: "На Главную",
      quickContact: "Быстрый Контакт",
      sendInquiry: "Отправить",
      name: "Ваше Имя",
      email: "Email",
      message: "Сообщение",
      sending: "Отправка...",
      sent: "Сообщение отправлено!"
    },
    aggregator: {
      hero: {
        label: "Game Aggregation",
        title: "iGaming Aggregator",
        subtitle: "Доступ к 10,000+ казино-игр от 100+ премиум-провайдеров через единую API интеграцию."
      },
      stats: [
        { value: "10,000+", label: "Игр" },
        { value: "100+", label: "Провайдеров" },
        { value: "99.9%", label: "Аптайм" },
        { value: "50мс", label: "Время Отклика" }
      ],
      features: [
        { title: "Единая API Интеграция", desc: "Подключитесь один раз и получите доступ ко всем провайдерам." },
        { title: "Обновления в Реальном Времени", desc: "Игры автоматически обновляются." },
        { title: "Единый Кошелек", desc: "Одна система кошелька для всех игр." },
        { title: "Панель Аналитики", desc: "Полная отчетность с аналитикой." },
        { title: "Интегрированный Бонусный Движок", desc: "Применяйте бонусы во всех играх." },
        { title: "Мультивалютная Поддержка", desc: "50+ фиатных валют и крипто." }
      ],
      partners: [
        "1Spin4win", "172 Gaming", "5 Men", "Amatic", "Apollo", "Asia Gaming", "Belatra", "Bet2 Tech", "Betsoft", "BGaming",
        "Big Time Gaming", "Blueprint", "Booming Games", "Booongo", "Casino Technology", "EGT", "EGT Digital", "ELK Studios",
        "Endorphina", "Evolution Gaming", "Evoplay", "Ezugi", "Fantasma", "Fazi", "Felix Gaming", "Fugaso", "GameArt",
        "Gamomat", "Golden Hero", "Goldenrace", "Habanero", "Hacksaw Gaming", "High5", "Hollegames", "iSoftBet",
        "Iron Dog Studio", "Kalamba", "Kiron", "Live Games", "Lucky Streak", "Mancala", "Mascot Gaming", "Microgaming",
        "Mr Slotty", "NetEnt", "NetGame", "Nolimit City", "Onlyplay", "Oryx", "Platiplus", "Play'n GO", "Playson",
        "Playtech", "Playtech Live", "Pragmatic Play", "Pragmatic PLAY Live", "Push Gaming", "Quickspin", "Red Rake Gaming",
        "Red Tiger Gaming", "Reevo", "Relax Gaming", "Smartsoft", "Spade Gaming", "Spearhead", "Spinomenal", "Spribe",
        "Swintt", "Thunderkick", "Tom Horn", "Vivo Gaming", "Wazdan", "Yggdrasil", "Apparat Gaming", "BeeFee Gaming",
        "Bet Games", "Caleta Gaming", "Darwin Gaming", "DLV Games", "G Games", "Jade Rabbit", "JVL", "Koreagaming",
        "Live88", "Microgaming Live", "Novomatic", "Pascal", "Peter & Sons", "PG Soft", "Popok", "RAW iGaming",
        "Rival Powered", "RubyPlay", "Skywind", "Skywind Live", "Stakelogic", "Stakelogic Live", "TopSpin Games",
        "Turbo Games", "Upgaming", "Urgent Games", "WinFast", "WorldMatch", "Xpro Gaming", "YGR Games"
      ],
      integration: [
        { step: 1, title: "Подписание Договора", desc: "Завершите партнерское соглашение." },
        { step: 2, title: "API Интеграция", desc: "Интегрируйте наш единый API." },
        { step: 3, title: "Тестирование", desc: "Тестируйте в sandbox среде." },
        { step: 4, title: "Запуск", desc: "Запустите с доступом к 10,000+ играм." }
      ],
      faq: [
        { q: "Сколько занимает интеграция?", a: "Обычно 2-4 недели." },
        { q: "Какие валюты поддерживаются?", a: "50+ фиат и все основные крипто." },
        { q: "Есть минимальный объем?", a: "Гибкие планы для всех размеров." },
        { q: "Есть техподдержка?", a: "Да, 24/7 с выделенным менеджером." }
      ]
    },
    platform: {
      hero: {
        label: "White Label Решение",
        title: "iGaming Platform",
        subtitle: "Запустите онлайн-казино за недели с нашей настраиваемой white-label платформой."
      },
      stats: [
        { value: "500+", label: "Активных Казино" },
        { value: "2 Недели", label: "Время Запуска" },
        { value: "24/7", label: "Поддержка" },
        { value: "100%", label: "Настраиваемость" }
      ],
      features: [
        { title: "Полное Решение для Казино", desc: "Всё что нужно." },
        { title: "Кастомный Брендинг", desc: "Полностью настраиваемый дизайн." },
        { title: "Управление Игроками", desc: "Продвинутые CRM инструменты." },
        { title: "Ответственная Игра", desc: "Встроенные инструменты защиты." },
        { title: "Мультитенантная Архитектура", desc: "Несколько брендов, одна платформа." },
        { title: "Регуляторное Соответствие", desc: "Предварительно настроенные инструменты." }
      ],
      partners: ["MGA Лицензия", "Curacao eGaming", "UKGC Ready", "ISO 27001", "GLI Сертификат", "eCOGRA"],
      integration: [
        { step: 1, title: "Требования", desc: "Поделитесь вашими требованиями." },
        { step: 2, title: "Настройка", desc: "Мы настроим платформу." },
        { step: 3, title: "Обучение", desc: "Полное обучение команды." },
        { step: 4, title: "Запуск", desc: "Запуск с постоянной поддержкой." }
      ],
      faq: [
        { q: "Могу использовать свой домен?", a: "Да, полностью под вашим брендом." },
        { q: "Какие лицензии нужны?", a: "Консультируем по лицензиям." },
        { q: "Исходный код включен?", a: "SaaS и исходный код доступны." },
        { q: "Как работают обновления?", a: "Автоматически без простоев." }
      ]
    },
    payments: {
      hero: {
        label: "Обработка Платежей",
        title: "iGaming Payments",
        subtitle: "Бесшовная обработка с 200+ методами оплаты."
      },
      stats: [
        { value: "200+", label: "Методов" },
        { value: "€50B+", label: "Ежегодно" },
        { value: "3с", label: "Среднее Время" },
        { value: "150+", label: "Стран" }
      ],
      features: [
        { title: "Глобальное Покрытие", desc: "Платежи из 150+ стран." },
        { title: "Мгновенные Депозиты", desc: "Обработка в реальном времени." },
        { title: "Умная Маршрутизация", desc: "AI оптимизация." },
        { title: "Предотвращение Мошенничества", desc: "Продвинутое обнаружение." },
        { title: "Защита от Chargebacks", desc: "Полное управление." },
        { title: "Автоматические Выплаты", desc: "Запланированные выводы." }
      ],
      partners: ["Visa", "Mastercard", "Skrill", "Neteller", "PayPal", "Apple Pay", "Google Pay", "Перевод"],
      integration: [
        { step: 1, title: "Регистрация", desc: "Полная KYB верификация." },
        { step: 2, title: "Интеграция", desc: "Внедрите наш API." },
        { step: 3, title: "Настройка", desc: "Настройте методы." },
        { step: 4, title: "Обработка", desc: "Начните с мониторингом." }
      ],
      faq: [
        { q: "Какие комиссии?", a: "Зависит от метода и объема." },
        { q: "Скорость выводов?", a: "Обычно в течение 24ч." },
        { q: "Конвертация валют?", a: "Да, конкурентные курсы." },
        { q: "Высокорисковая обработка?", a: "Специализируемся на iGaming." }
      ]
    },
    crypto: {
      hero: {
        label: "Крипто Решения",
        title: "Crypto Payments",
        subtitle: "Принимайте 50+ криптовалют с мгновенным расчетом."
      },
      stats: [
        { value: "50+", label: "Криптовалют" },
        { value: "0%", label: "Chargebacks" },
        { value: "<1мин", label: "Расчет" },
        { value: "0.5%", label: "Комиссия" }
      ],
      features: [
        { title: "Мультичейн Поддержка", desc: "Bitcoin, Ethereum, BSC, Tron, Solana." },
        { title: "Мгновенная Конвертация", desc: "Авто-конвертация в стейблкоины." },
        { title: "Ноль Chargebacks", desc: "Транзакции необратимы." },
        { title: "Hot & Cold Кошельки", desc: "Корпоративная безопасность." },
        { title: "Поддержка Стейблкоинов", desc: "USDT, USDC, DAI." },
        { title: "DeFi Интеграция", desc: "Опциональная генерация дохода." }
      ],
      partners: ["Bitcoin", "Ethereum", "USDT", "USDC", "Litecoin", "Ripple", "Solana", "Tron"],
      integration: [
        { step: 1, title: "Настройка Кошелька", desc: "Настройте ваши адреса." },
        { step: 2, title: "API Интеграция", desc: "Внедрите наш крипто API." },
        { step: 3, title: "Тестирование", desc: "Тестируйте в testnets." },
        { step: 4, title: "Запуск", desc: "Принимайте крипто платежи." }
      ],
      faq: [
        { q: "Как справляетесь с волатильностью?", a: "Мгновенная конвертация в стейблкоины." },
        { q: "Регуляторное соответствие?", a: "Полные KYC/AML инструменты." },
        { q: "Лимиты объема?", a: "Без лимитов." },
        { q: "Безопасность системы?", a: "Корпоративная безопасность со страховкой." }
      ]
    }
  },
  el: {
    common: {
      getStarted: "Ξεκινήστε",
      requestDemo: "Ζητήστε Demo",
      contactUs: "Επικοινωνία",
      learnMore: "Μάθετε Περισσότερα",
      integration: "Βήματα Ενσωμάτωσης",
      faq: "Συχνές Ερωτήσεις",
      partners: "Οι Συνεργάτες μας",
      features: "Βασικά Χαρακτηριστικά",
      benefits: "Οφέλη",
      stats: "Σε Αριθμούς",
      backToHome: "Επιστροφή",
      quickContact: "Γρήγορη Επικοινωνία",
      sendInquiry: "Αποστολή",
      name: "Το Όνομά σας",
      email: "Email",
      message: "Μήνυμα",
      sending: "Αποστολή...",
      sent: "Το μήνυμα στάλθηκε!"
    },
    aggregator: {
      hero: {
        label: "Game Aggregation",
        title: "iGaming Aggregator",
        subtitle: "Πρόσβαση σε 10.000+ παιχνίδια καζίνο από 100+ κορυφαίους παρόχους μέσω μιας API."
      },
      stats: [
        { value: "10.000+", label: "Παιχνίδια" },
        { value: "100+", label: "Πάροχοι" },
        { value: "99,9%", label: "Uptime" },
        { value: "50ms", label: "Χρόνος Απόκρισης" }
      ],
      features: [
        { title: "Ενιαία API Ενσωμάτωση", desc: "Συνδεθείτε μία φορά και αποκτήστε πρόσβαση σε όλους τους παρόχους." },
        { title: "Ενημερώσεις σε Πραγματικό Χρόνο", desc: "Τα παιχνίδια ενημερώνονται αυτόματα." },
        { title: "Ενοποιημένο Πορτοφόλι", desc: "Ένα σύστημα πορτοφολιού για όλα τα παιχνίδια." },
        { title: "Πίνακας Αναλυτικών", desc: "Πλήρης αναφορά με αναλυτικά στοιχεία." },
        { title: "Ενσωματωμένη Μηχανή Μπόνους", desc: "Εφαρμόστε μπόνους σε όλα τα παιχνίδια." },
        { title: "Υποστήριξη Πολλαπλών Νομισμάτων", desc: "50+ νομίσματα και crypto." }
      ],
      partners: [
        "1Spin4win", "172 Gaming", "5 Men", "Amatic", "Apollo", "Asia Gaming", "Belatra", "Bet2 Tech", "Betsoft", "BGaming",
        "Big Time Gaming", "Blueprint", "Booming Games", "Booongo", "Casino Technology", "EGT", "EGT Digital", "ELK Studios",
        "Endorphina", "Evolution Gaming", "Evoplay", "Ezugi", "Fantasma", "Fazi", "Felix Gaming", "Fugaso", "GameArt",
        "Gamomat", "Golden Hero", "Goldenrace", "Habanero", "Hacksaw Gaming", "High5", "Hollegames", "iSoftBet",
        "Iron Dog Studio", "Kalamba", "Kiron", "Live Games", "Lucky Streak", "Mancala", "Mascot Gaming", "Microgaming",
        "Mr Slotty", "NetEnt", "NetGame", "Nolimit City", "Onlyplay", "Oryx", "Platiplus", "Play'n GO", "Playson",
        "Playtech", "Playtech Live", "Pragmatic Play", "Pragmatic PLAY Live", "Push Gaming", "Quickspin", "Red Rake Gaming",
        "Red Tiger Gaming", "Reevo", "Relax Gaming", "Smartsoft", "Spade Gaming", "Spearhead", "Spinomenal", "Spribe",
        "Swintt", "Thunderkick", "Tom Horn", "Vivo Gaming", "Wazdan", "Yggdrasil", "Apparat Gaming", "BeeFee Gaming",
        "Bet Games", "Caleta Gaming", "Darwin Gaming", "DLV Games", "G Games", "Jade Rabbit", "JVL", "Koreagaming",
        "Live88", "Microgaming Live", "Novomatic", "Pascal", "Peter & Sons", "PG Soft", "Popok", "RAW iGaming",
        "Rival Powered", "RubyPlay", "Skywind", "Skywind Live", "Stakelogic", "Stakelogic Live", "TopSpin Games",
        "Turbo Games", "Upgaming", "Urgent Games", "WinFast", "WorldMatch", "Xpro Gaming", "YGR Games"
      ],
      integration: [
        { step: 1, title: "Υπογραφή Συμφωνίας", desc: "Ολοκληρώστε τη συμφωνία συνεργασίας." },
        { step: 2, title: "Ενσωμάτωση API", desc: "Ενσωματώστε το ενοποιημένο API μας." },
        { step: 3, title: "Δοκιμές", desc: "Δοκιμάστε στο sandbox περιβάλλον μας." },
        { step: 4, title: "Εκκίνηση", desc: "Ξεκινήστε με πρόσβαση σε 10.000+ παιχνίδια." }
      ],
      faq: [
        { q: "Πόσο διαρκεί η ενσωμάτωση;", a: "Συνήθως 2-4 εβδομάδες." },
        { q: "Ποια νομίσματα υποστηρίζονται;", a: "50+ fiat και όλα τα κύρια crypto." },
        { q: "Υπάρχει ελάχιστος όγκος;", a: "Ευέλικτα πλάνα για όλα τα μεγέθη." },
        { q: "Παρέχετε τεχνική υποστήριξη;", a: "Ναι, 24/7 με αποκλειστικό διαχειριστή." }
      ]
    },
    platform: {
      hero: {
        label: "White Label Λύση",
        title: "iGaming Platform",
        subtitle: "Ξεκινήστε το online καζίνο σας σε εβδομάδες με την πλήρως προσαρμόσιμη white-label πλατφόρμα μας."
      },
      stats: [
        { value: "500+", label: "Ενεργά Καζίνο" },
        { value: "2 Εβδομάδες", label: "Χρόνος Εκκίνησης" },
        { value: "24/7", label: "Υποστήριξη" },
        { value: "100%", label: "Προσαρμόσιμο" }
      ],
      features: [
        { title: "Πλήρης Λύση Καζίνο", desc: "Όλα όσα χρειάζεστε." },
        { title: "Προσαρμοσμένο Branding", desc: "Πλήρως προσαρμόσιμος σχεδιασμός." },
        { title: "Διαχείριση Παικτών", desc: "Προηγμένα εργαλεία CRM." },
        { title: "Υπεύθυνο Παιχνίδι", desc: "Ενσωματωμένα εργαλεία προστασίας." },
        { title: "Multi-Tenant Αρχιτεκτονική", desc: "Πολλαπλά brands, μία πλατφόρμα." },
        { title: "Κανονιστική Συμμόρφωση", desc: "Προρυθμισμένα εργαλεία συμμόρφωσης." }
      ],
      partners: ["MGA Αδειοδοτημένο", "Curacao eGaming", "UKGC Ready", "ISO 27001", "GLI Πιστοποιημένο", "eCOGRA"],
      integration: [
        { step: 1, title: "Απαιτήσεις", desc: "Μοιραστείτε τις απαιτήσεις σας." },
        { step: 2, title: "Ρύθμιση", desc: "Διαμορφώνουμε την πλατφόρμα." },
        { step: 3, title: "Εκπαίδευση", desc: "Πλήρης εκπαίδευση ομάδας." },
        { step: 4, title: "Εκκίνηση", desc: "Live με συνεχή υποστήριξη." }
      ],
      faq: [
        { q: "Μπορώ να χρησιμοποιήσω το δικό μου domain;", a: "Ναι, πλήρως υπό το brand σας." },
        { q: "Ποιες άδειες χρειάζομαι;", a: "Συμβουλεύουμε για άδειες." },
        { q: "Περιλαμβάνεται ο πηγαίος κώδικας;", a: "SaaS και πηγαίος κώδικας διαθέσιμα." },
        { q: "Πώς λειτουργούν οι ενημερώσεις;", a: "Αυτόματα χωρίς διακοπή." }
      ]
    },
    payments: {
      hero: {
        label: "Επεξεργασία Πληρωμών",
        title: "iGaming Payments",
        subtitle: "Απρόσκοπτη επεξεργασία με 200+ μεθόδους πληρωμής."
      },
      stats: [
        { value: "200+", label: "Μέθοδοι" },
        { value: "€50B+", label: "Ετησίως" },
        { value: "3δλ", label: "Μέσος Χρόνος" },
        { value: "150+", label: "Χώρες" }
      ],
      features: [
        { title: "Παγκόσμια Κάλυψη", desc: "Πληρωμές από 150+ χώρες." },
        { title: "Άμεσες Καταθέσεις", desc: "Επεξεργασία σε πραγματικό χρόνο." },
        { title: "Έξυπνη Δρομολόγηση", desc: "Βελτιστοποίηση AI." },
        { title: "Πρόληψη Απάτης", desc: "Προηγμένη ανίχνευση." },
        { title: "Προστασία Chargeback", desc: "Πλήρης διαχείριση." },
        { title: "Αυτοματοποιημένες Πληρωμές", desc: "Προγραμματισμένες αναλήψεις." }
      ],
      partners: ["Visa", "Mastercard", "Skrill", "Neteller", "PayPal", "Apple Pay", "Google Pay", "Μεταφορά"],
      integration: [
        { step: 1, title: "Εγγραφή", desc: "Πλήρης επαλήθευση KYB." },
        { step: 2, title: "Ενσωμάτωση", desc: "Υλοποιήστε το API μας." },
        { step: 3, title: "Διαμόρφωση", desc: "Ρυθμίστε τις μεθόδους." },
        { step: 4, title: "Επεξεργασία", desc: "Ξεκινήστε με παρακολούθηση." }
      ],
      faq: [
        { q: "Ποιες είναι οι χρεώσεις;", a: "Ανάλογα με μέθοδο και όγκο." },
        { q: "Ταχύτητα αναλήψεων;", a: "Συνήθως εντός 24ω." },
        { q: "Μετατροπή νομίσματος;", a: "Ναι, ανταγωνιστικές τιμές." },
        { q: "Επεξεργασία υψηλού ρίσκου;", a: "Εξειδικευμένοι στο iGaming." }
      ]
    },
    crypto: {
      hero: {
        label: "Crypto Solutions",
        title: "Crypto Payments",
        subtitle: "Αποδεχτείτε 50+ κρυπτονομίσματα με άμεσο διακανονισμό."
      },
      stats: [
        { value: "50+", label: "Κρυπτονομίσματα" },
        { value: "0%", label: "Chargebacks" },
        { value: "<1λεπτό", label: "Διακανονισμός" },
        { value: "0,5%", label: "Χρέωση" }
      ],
      features: [
        { title: "Multi-Chain Υποστήριξη", desc: "Bitcoin, Ethereum, BSC, Tron, Solana." },
        { title: "Άμεση Μετατροπή", desc: "Αυτόματη μετατροπή σε stablecoins." },
        { title: "Μηδέν Chargebacks", desc: "Οι συναλλαγές είναι μη αναστρέψιμες." },
        { title: "Hot & Cold Πορτοφόλια", desc: "Εταιρική ασφάλεια." },
        { title: "Υποστήριξη Stablecoin", desc: "USDT, USDC, DAI." },
        { title: "DeFi Ενσωμάτωση", desc: "Προαιρετική δημιουργία απόδοσης." }
      ],
      partners: ["Bitcoin", "Ethereum", "USDT", "USDC", "Litecoin", "Ripple", "Solana", "Tron"],
      integration: [
        { step: 1, title: "Ρύθμιση Πορτοφολιού", desc: "Ρυθμίστε τις διευθύνσεις σας." },
        { step: 2, title: "Ενσωμάτωση API", desc: "Υλοποιήστε το crypto API μας." },
        { step: 3, title: "Δοκιμές", desc: "Δοκιμάστε σε testnets." },
        { step: 4, title: "Εκκίνηση", desc: "Αποδεχτείτε crypto πληρωμές." }
      ],
      faq: [
        { q: "Διαχείριση μεταβλητότητας;", a: "Άμεση μετατροπή σε stablecoins." },
        { q: "Κανονιστική συμμόρφωση;", a: "Πλήρη εργαλεία KYC/AML." },
        { q: "Όρια όγκου;", a: "Χωρίς όρια." },
        { q: "Ασφάλεια συστήματος;", a: "Εταιρική ασφάλεια με ασφάλιση." }
      ]
    }
  }
};
